// removed by extract-text-webpack-plugin
module.exports = {"footer":"Footer__footer__ypf3k","humidity":"Footer__humidity__LWRY7","wind":"Footer__wind__3_yUi","img1":"Footer__img1__K4zF7","img2":"Footer__img2__1_2W8","span1":"Footer__span1__3IOH1","span2":"Footer__span2__2HXWS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.css
// module id = 71
// module chunks = 0